import React from "react";
const SiteMetaContext = React.createContext();
SiteMetaContext.displayName = "SiteMetaContext";
export default SiteMetaContext;
